module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAMAAAC6V+0/AAAAPFBMVEVHcEwQf8MAL4UERZYBN4sBN4sOdrwBN4sBN4sOdrwKZrABNYoANIgHVKIOdrwBN4sHVaMAMocOeL4Pe8DXAPW/AAAADnRSTlMAJChZMzEu9vovVjP6+PfbaboAAABQSURBVBjTzc5LFkAwEAXRR9ARoj/Z/14NJHFoC1DDOyocLstwVoTgTR2aKF+Y1l5SrjigN3LD5cb5z/g1b2GbWqFiEeVHBG9MMGdMyHt8Ryde6w6mRSlpfQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/images/favAzul.png
// module id = 104
// module chunks = 168707334958949